'use client';

import { HelmetProvider } from 'react-helmet-async';

const HelmetProviderWrapper = ({ children }) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default HelmetProviderWrapper;
